var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9056 19.3947L10.9058 19.3945L10.9098 19.4005C11.1912 19.8163 11.1609 20.4051 10.8155 20.7839C10.4312 21.2054 9.80408 21.2054 9.41983 20.7839L1.18454 11.7517L1.18435 11.7519L1.17986 11.7461L1.09442 11.6376L1.09422 11.6378L1.09017 11.6318C0.808848 11.2159 0.839143 10.6272 1.18454 10.2483L9.41983 1.21607L9.41963 1.21589L9.42498 1.21083L9.52394 1.11713L9.52374 1.11693L9.52957 1.11218C9.91641 0.79738 10.4667 0.833555 10.8155 1.21607L10.8157 1.21589L10.8201 1.2216L10.9056 1.33014L10.9058 1.32997L10.9098 1.33595C11.1912 1.7518 11.1609 2.34059 10.8155 2.71941L3.26591 11L10.8155 19.2806L10.8157 19.2804L10.8201 19.2861L10.9056 19.3947Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.857df386.svg";
export { ForwardRef as ReactComponent };